<template>
  <v-row
    justify="center"
    align="center"
    no-gutters
    class="fill-height"
  >
    <v-col
      cols="12"
    >
      <v-row
        justify="center"
        no-gutters
      >
        <v-col
          cols="12"
          class="py-2"
        />

        <v-col
          cols="11"
          md="9"
          lg="7"
          xl="5"
        >
          <v-card
            class="pa-3 mx-auto"
            flat
            max-width="375"
            light
          >
            <v-form>
              <v-row>
                <v-col
                  v-if="!urlShortcutShrink"
                  cols="12"
                >
                  <!-- @vue-ignore -->
                  <v-text-field
                    ref="modelInputsListUrl"
                    id="url"
                    type="url"
                    solo
                    placeholder="URL"
                    title="URL"
                    alt="Digite a URL de destino"
                    :prefix="modelInputsListUrlPrefix"
                    hide-details="auto"
                    @input="(v) => debounce(() => changeInput('url', v))"
                  >
                    <template
                      v-slot:append
                    >
                      <v-btn
                        v-if="urlPreview.href"
                        icon
                        title="Shrink"
                        alt="Encurte a URL e obtenha dados de uso"
                        width="28"
                        height="28"
                        large
                        @click="urlShortcutAction()"
                      >
                        <v-icon
                          class="material-symbols-outlined"
                        >
                          step
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col
                  cols="12"
                >
                  <v-expansion-panels
                    v-model="toggleAdvancedModePanel"
                    multiple
                    eager
                  >
                    <v-expansion-panel
                      class="--fix-expansion-panel-fluid"
                    >
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col
                            v-if="!urlShortcutShrink"
                            cols="12"
                          >
                            <v-row>
                              <v-col
                                v-for="{ title, id, alt } in queryBuilderInputs"
                                :key="`text-field-${id}`"
                                cols="12"
                                class="--fix-col-text-field-hint-details"
                              >
                                <!-- @vue-ignore -->
                                <v-text-field
                                  :id="id"
                                  class="--fix-text-field-hint-details --fix-text-field-style-solo"
                                  :ref="`query_input_${id}`"
                                  dense
                                  outlined
                                  :placeholder="title"
                                  :title="title"
                                  :alt="alt"
                                  :label="showInputLabelRefMessage(`query_input_${id}`) ? title : ''"
                                  persistent-placeholder
                                  hide-details="auto"
                                  append-icon="remove"
                                  @input="(v) => changeInput(id, v)"
                                  @click:append="removeInput(id)"
                                />
                              </v-col>

                              <v-col
                                cols="12"
                              >
                                <v-text-field
                                  id="createnewinput"
                                  ref="createnewinput"
                                  placeholder="Novo parametro"
                                  dense
                                  solo
                                  title="Digite um novo parametro"
                                  alt="Digite um novo parametro"
                                  hide-details="auto"
                                  append-icon="check"
                                  @keydown.enter="createNewInput($refs.createnewinput); $refs.createnewinput.reset()"
                                  @click:append="createNewInput($refs.createnewinput); $refs.createnewinput.reset()"
                                />
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col
                            cols="12"
                          >
                            <v-textarea
                              :value="urlPreview.href"
                              readonly
                              hide-details
                              dense
                              solo
                              auto-grow
                              placeholder="Link parametrizado"
                              append-icon="content_copy"
                              @click="copy(urlPreview.href)"
                              @click:append="copy(urlPreview.href)"
                            />
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>

                <v-col
                  v-if="urlShortcutShrink"
                  cols="12"
                >
                  <v-text-field
                    :value="urlShortcut"
                    readonly
                    outlined
                    dense
                    append-icon="content_copy"
                    @click="copy(urlShortcut)"
                    @click:append="copy(urlShortcut)"
                  />
                </v-col>

                <v-col
                  v-if="urlShortcutShrink"
                  cols="12"
                >
                  <v-btn
                    depressed
                    color="secondary"
                    block
                    class="text-none"
                    rounded
                    large
                    @click="restartApp()"
                  >
                    Criar outra URL
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          class="py-10"
        />
      </v-row>
    </v-col>

    <v-col
      cols="12"
      :style="`position: fixed; z-index: 999; bottom: ${installed ? 36 : 0}px;`"
    >
      <componentUserMenubar
        :urlPreview="urlPreview.href"
        :urlShortcut="urlShortcut"
        :toggleAdvancedModePanel="toggleAdvancedModePanel"
        @urlShortcut="urlShortcutAction"
        @toggleAdvancedMode="toggleAdvancedMode"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
  import { Component } from "vue-property-decorator"
  import { mixins } from "vue-class-component"
  import { mixinViewHome } from "@/mixins/mixinViewHome"
  import "@/styles/styleInput.styl"
  import "@/styles/styleExpansionPanel.styl"

  @Component({
    components: {
      componentUserMenubar: () => import(
        /* webpackChunkName: "menu-bar-component" */
        /* webpackFetchPriority: "low" */
        /* webpackMode: "lazy" */
        "@/component/componentUserMenubar.vue"
      )
    }
  })
  export default class viewHome extends mixins(
    mixinViewHome,
  ) {}
</script>
